import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Row, Col } from 'antd';
import { getChildrenToRender } from '../utils';
import { isImg } from '../utils';
import {Link} from "react-router-dom";
import qrCode from "../img/meehoo.jpg";

class Footer extends React.Component {
  static defaultProps = {
    className: 'footer1',
  };
    getLiChildren = (data) =>
    data.map((item, i) => {
      const { title, childWrapper, ...itemProps } = item;
      return (
        <Col key={i.toString()} {...itemProps} title={null} content={null}>
          <h2 {...title}>
            {typeof title.children === 'string' &&
            title.children.match(isImg) ? (
              <img src={title.children} width="100%" alt="img" />
            ) : (
              title.children
            )}
          </h2>
          <div {...childWrapper}>

            {/*{childWrapper.children.map(getChildrenToRender)}*/}
            {childWrapper.children.map((item, index) =>{
              return item.href ? (
                <Link to={{ pathname: item.href , state: { name: item.name } }} key={index}>{item.children}</Link>
              ) : <span style={{ cursor: 'pointer' }} key={index}>{item.children}</span>
            })}

          </div>
        </Col>
      );
    });

  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    const childrenToRender = this.getLiChildren(dataSource.block.children);
    return (
      <div {...props} {...dataSource.wrapper}>
        <OverPack {...dataSource.OverPack}>
          <Row className="home-page k4ni2gldh8-editor_css" gutter={0}>
            {childrenToRender}
            {/*<Col span={4}>*/}
            {/*    <img src={qrCode} alt="qrCode" width={102}/>*/}
            {/*  <div style={{display: 'flex', justifyContent: 'center', width: 102}}>*/}
            {/*    <p>关注官方微信</p>*/}
            {/*  </div>*/}
            {/*</Col>*/}
          </Row>
          <TweenOne
            animation={{ y: '+=30', opacity: 0, type: 'from' }}
            key="copyright"
            {...dataSource.copyrightWrapper}
          >
            <div {...dataSource.copyrightPage}>
              <div {...dataSource.copyright}>
                {dataSource.copyright.children}
              </div>
            </div>
          </TweenOne>
        </OverPack>
      </div>
    );
  }
}

export default Footer;
